export const GUEST_EMAIL = "ihnsocialmediaa@gmail.com";

export const enquiryOptions = [
  { value:"",            label:"Select enquiry type…" },
  { value:"general",     label:"General Enquiry" },
  { value:"application", label:"Application Status" },
  { value:"refund",      label:"Refund / Cancellation" },
  { value:"documents",   label:"Document Help" },
  { value:"emergency",   label:"Emergency / Urgent" },
];

export const topics = [
  "Visa Application Guidance",
  "Document Checklist Review",
  "Application Status Update",
  "Refund / Cancellation Help",
  "Emergency Visa Processing",
  "Other",
];

export const timeSlots = [
  "09:30 AM","10:00 AM","11:00 AM","12:00 PM",
  "02:00 PM","03:00 PM","04:00 PM","05:30 PM",
];

export async function fetchTimeSlots() {
  return timeSlots;
}